import 'vue/jsx'

// 引入unocss
import '@/plugins/unocss'

// 导入全局的svg图标
import '@/plugins/svgIcon'

// 初始化多语言
import { setupI18n } from '@/plugins/vueI18n'

// 引入状态管理
import { setupStore } from '@/store'

// 全局组件
import { setupGlobCom } from '@/components'

// 引入element-plus
import { setupElementPlus } from '@/plugins/elementPlus'

// 引入全局样式
import '@/styles/index.less'

// 引入动画
import '@/plugins/animate.css'

// 引入系统资源
import { useResourceStore } from '@/store/modules/resource'

// 路由
import { setupRouter } from './router'

// 全局过滤器
import { setupGlobalProperties } from '@/utils/globalProperties'

import { createApp } from 'vue'

import App from './App.vue'

import './permission'

// 创建实例
const setupAll = async () => {
  const app = createApp(App)
  await setupI18n(app)

  setupStore(app)
  const resourceStore = useResourceStore()
  await resourceStore.initOptions()

  setupGlobCom(app)

  setupElementPlus(app)

  setupRouter(app)

  app.mount('#app')

  // 全局属性
  setupGlobalProperties(app)
}

setupAll()
